import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  sendWebsocketMessage,
  disconnectWebsocket
} from "WEBSOCKET/WebsocketHandler";

// Components
import SplashScreen from "COMPONENTS/QRCode/UIComponents/SplashScreen/SplashScreen";
import AgentSplashScreen from "COMPONENTS/QRCode/UIComponents/SplashScreen/AgentSplashScreen";
import LoadingScreen from "COMPONENTS/QRCode/UIComponents/LoadingScreen/LoadingScreen";

// Utilities
import { getURLParameter, checkEmpty, getTerminalInfo } from "UTILS/Utility";

// Strings
import { getMessage, changeLanguage } from "CONFIG/i18n";

// Styles
import "./QRCode.less";

// Constants
import { socketMessage } from "WEBSOCKET/constants";

import {
  CONFIG,
  ERROR
} from "../../../Utils/Constants";

import {
  USER_ROLES,
  SESSION_STATUS,
  USER_ADMISSION_STATUS
} from "UTILS/Constants";

import {
  selectUserRole,
} from "../../Whiteboard/selectors";
import {
  selectSessionKey,
  selectUserToken,
  selectUserName,
  selectEndUserToken
} from "COMPONENTS/MainLayout/selectors";
import { 
  getLanguage, 
  selectSessionStatus, 
  selectSessionType,
  selectQrActiveScreen,
} from "./QRCodeSelector";

import { selectSessionEndedFlag } from "COMPONENTS/CommonComponents/Header/selectors.js"
import { selectUserAdmissionStatus } from "COMPONENTS/Dashboard/selectors";
import { getOwnSpeedTestError } from "REDUX/Selector/UserSelector"

// Actions
import { sessionActions, organisationAction } from "CONFIG/ActionFactory";
import {
  setLogoImage,
  setSharingFlag,
  setSdpFlag,
  setQrError,
  removeSessionKeyAndToken,
  updateLatestParticipant,
  setSessionStatus,
  removeSessionDetails,
  setQrActiveScreen,
  setQrLicenseKey,
  setIsDisabledMenu,
} from "./QRCodeAction";
import { logoutAction } from "CONFIG/ActionFactory";
import setLanguageAction from "COMPONENTS/CommonComponents/ChangeLanguage/setLanguageAction";
import { setToken, setCustomerId, updateProfile ,setUserRole} from "COMPONENTS/UserJoin/UserJoinAction";

// Images
import logo from "../../../Assets/Images/img_signin_bg_logo.webp";

import SpeedTestHelper from 'COMPONENTS/SpeedTest/speedTestHelper';
const speedTestHelper = new SpeedTestHelper();

class QRCodeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLanguage: this.props.selectedLanguage || "en",
      showVideoCallPopUp: false,
      deviceList: null,
      showAudio: false,
      isLogoPresent: null,
      isOtherAgentAttending: false,
      firstName: null,
      lastName: null,
      waitingScreenMessage: null,
      isSpeedTestRunning: true,
      speedTestCountTime: 15,
      speedTest: {},
    };
    this.speedTestCountDownInterval = null;

    // first check errors if user has copied qr code link on join / create session
    if (this.props.sessionStatus === SESSION_STATUS.ACTIVE) {
      /* remove session details 
        if user paste QR link on browser's tab where session is already running and user is on dashboard
      */
      this.props.removeSessionDetails();
      this.props.setQrActiveScreen("QR_SPLASH_SCREEN");
    }
    // on join session / create session screen in normal flow, sessionStatus = "" 
    // if (this.props.sessionStatus !== SESSION_STATUS.CREATED &&
    if(this.props.sessionType != "QR_CODE" &&
      (this.props.sessionKey || this.props.token)) {

      /* remove session details 
        if user paste QR link on browser's tab on join session screen after user has left from active session 
        or agent paste QR link on browser's tab on create session screen after he has ended the active session 
      */
      // to remove previous sessions'S DATA (token and session Key)
      this.props.removeSessionKeyAndToken();
      this.props.setQrActiveScreen("QR_SPLASH_SCREEN");
      //this.props.updateLatestParticipant();
      this.handleLogout();// To Clear login Token
    }

    const token = getURLParameter("token");
    this.licenseKey = getURLParameter("licenseKey");

    if (!this.licenseKey && !token) {
      this.props.setQrError(ERROR.INVALID_DATA_REQUEST)
      this.props.history.replace(CONFIG.path.qrExpired);
    }

    /* ############################## User side starts ############################## */

    if (this.licenseKey) {
      this.props.setUserRole(USER_ROLES.USER);
      this.props.setQrLicenseKey(this.licenseKey);

      // on new tab for user, need to set QrActiveScreen as SPLASH_SCREEN
      if(!this.props.sessionStatus) {
        this.props.setQrActiveScreen("QR_SPLASH_SCREEN");
      }
      // get customer logo and show splash screen to the user if license is valid
      organisationAction.getCustomerFromLicenseAction(this.licenseKey).then(
        response => {
          let logoUrl = response.data ? response.data.data.logoUrl : null;
          if (!logoUrl) {
            this.state.isLogoPresent = false;
            this.changeLogoToDefault();
          } else {
            this.props.setLogoImage(logoUrl);
            //this.props.setCustomerId(response.data.data.customerId)
            this.state.isLogoPresent = true;
            organisationAction.setLogoUrl(logoUrl)
          }

        },
        error => {
          if (error.code === ERROR.LICENSE_KEY_EXPIRED || error.code === ERROR.INVALID_LICENSE_KEY ||
            error.code === ERROR.CUSTOMER_NOT_ACTIVE || error.code === ERROR.INVALID_REQUEST_DATA) {
            var errorCode = this.getValidErrorCode(error.code);
            this.props.setQrError(errorCode)
            this.props.history.replace(CONFIG.path.qrExpired);
          }
          this.state.isLogoPresent = false;
          this.changeLogoToDefault();
          this.state.errorMessage = error.code;
        }
      );
      this.startSpeedTest();
    }
    /* ############################## User side ends ############################## */

    /* ############################## Agent side ############################## */
    this.sessionKey = getURLParameter("sessionKey");
    let language = getURLParameter("language");
    token && this.props.setToken(token);
    !this.licenseKey && this.props.setUserRole(USER_ROLES.AGENT);
    this.props.setQrError(null);
    if (language) {
      changeLanguage(language);
      this.props.setLanguageAction(language);
      this.state.selectedLanguage = language;
    }

    if (token) {
      // for agent, need to set QrActiveScreen as null as we directly want to load dashboard
      this.props.setQrActiveScreen(null);
      this.state.firstName = getURLParameter("firstname");
      this.state.lastName = getURLParameter("lastname");
    }

    if (!this.licenseKey) {
      const isDisabledMenu = getURLParameter("isDisabledMenu");
      this.props.setIsDisabledMenu(isDisabledMenu === "1");
    }
  }

  getValidErrorCode = (errorCode) => {
    if (errorCode === ERROR.CUSTOMER_NOT_ACTIVE)
      return ERROR.LICENSE_KEY_EXPIRED
    if (errorCode === ERROR.INVALID_REQUEST_DATA)
      return ERROR.INVALID_LICENSE_KEY;

    return errorCode;
  }

  handleLogout = () => {
    logoutAction.logoutreducerAction();
  };

  componentDidMount() {
    if (!this.licenseKey) {
      this.checkSession();
    }
  }
  
  componentDidUpdate(prevProps) {
    // hide splash screen after agent joins the session and session status becomes ACTIVE
    if (this.props.sessionStatus === SESSION_STATUS.ACTIVE &&
      this.props.sessionStatus !== prevProps.sessionStatus) {
      // navigate user / agent to the Dashboard
      this.props.history.push(CONFIG.path.dashboard);
    } 
    if(this.props.isSessionEnded){
      this.props.history.push(CONFIG.path.sessionEnded);
    }
    if(this.props.userAdmissionStatus === USER_ADMISSION_STATUS.REJECTED){
      this.props.history.push(CONFIG.path.waitingRoom);
    }
  }

  componentWillUnmount() {
    speedTestHelper.clear();
    if (typeof this.speedTestCountDownInterval === "number") {
      clearInterval(this.speedTestCountDownInterval);
    }
  }

  startSpeedTest = () => {
    sessionActions.setOwnSpeedTestError(null);
    
    this.speedTestCountDownInterval = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.speedTestCountTime <= 0) {
          clearInterval(this.speedTestCountDownInterval);
        } else {
          return { speedTestCountTime: prevState.speedTestCountTime -1 };
        }
      });
    }, 1000);

    speedTestHelper.startSpeedTest(
      this.onComplete,
      this.onServerError,
      this.onTimeoutError,
    );
  }

  onComplete = (speedTest) => {
    this.setState({ 
      isSpeedTestRunning: false,
      speedTest,
    });
  }
  onServerError = () => {
    this.setState({ 
      isSpeedTestRunning: false,
      speedTest: {
        result: -1,
      }
    });
  }
  onTimeoutError = () => {
    sessionActions.setOwnSpeedTestError(ERROR.SPEED_TEST_TIME_OUT);
    this.setState({ 
      isSpeedTestRunning: false,
      speedTest: {
        result: -1,
      }
    });
  }
  
  handleChangeLanguage = selectedLanguage => {
    this.props.setLanguageAction(selectedLanguage);
    this.setState({ selectedLanguage: selectedLanguage });
  };

  // called when user enters his name and say Start
  handleStartClick = (errorCallBack, userName) => {
    let user = userName; 
    if(checkEmpty(user.trim())) {
      user = getMessage("GUEST");
    }

    // for user
    if (this.props.userRole === USER_ROLES.USER) {    
      const licenseKey = getURLParameter("licenseKey");
      const sessionName = getMessage("QR_SESSION_OF") + user;
      let language = this.state.selectedLanguage;

      // create a new session for user
      sessionActions.createSessionWithLicenseAction(licenseKey, language, sessionName).then(
        data => {
          // call join session for user
          getTerminalInfo().then ( terminalInfo => {
            sessionActions.joinSessionAction(data.sessionKey, this.props.uriIdentifier, terminalInfo, this.state.speedTest, user).then(
              response => {
                let sessionJoinPayload = {
                  data: {
                    category: socketMessage.category.SESSION,
                    action: socketMessage.subCategories.SESSION.JOIN_SESSION_REQUEST,
                    userName: user,
                    sessionKey: response.data.data.sessionKey,
                    token: response.data.data.token
                  }
                };
                this.props.sendWebsocketMessage(
                  socketMessage.events.MESSAGE,
                  sessionJoinPayload
                );
                this.props.setSessionStatus(response.data.data.sessionStatus);
                let startBtn = document.getElementById("startQRSessionBtn");
                if(startBtn) {
                  startBtn.disabled = false;
                }
                this.props.setQrActiveScreen("QR_WAITING_SCREEN");
              },
              error => {
                errorCallBack(error.code)
              }
            );
          });
        },
        error => {
          errorCallBack(error.code)
        }
      );
    }
  };

  // called when Agnet enters and say Start
  handleAgentStartClick = () => {
    sessionActions.joinSessionAction(this.sessionKey, this.props.uriIdentifier).then(
      response => {
        let logoUrl = response.data ? response.data.data.logoUrl : null;
        this.props.setToken(response.data.data.token);
        this.props.setCustomerId(response.data.data.customerId);
        if (logoUrl) {
          this.props.setLogoImage(logoUrl);
          organisationAction.setLogoUrl(logoUrl);
        }
        else {
          this.changeLogoToDefault();
        }
        // update user profile for Agent to show his Initials
        this.props.updateProfile({ first_name: this.state.firstName, last_name: this.state.lastName })

        organisationAction.getCustomersAction(response.data.data.customerId).then(
          responseObject => {
          }, error => {
            console.error("Error getting customer info", error);
          }
        );

        let sessionJoinPayload = {
          data: {
            category: socketMessage.category.SESSION,
            action: socketMessage.subCategories.SESSION.JOIN,
            userName: this.props.userName,
            sessionKey: response.data.data.sessionKey,
            token: response.data.data.token
          }
        };
        // if (userToken) {
        //   sessionJoinPayload.data.token = userToken;
        // }
        this.props.sendWebsocketMessage(
          socketMessage.events.MESSAGE,
          sessionJoinPayload
        );
      },
      error => {
        if (error.code === ERROR.NOT_AUTHORIZED) {
          this.props.history.push(CONFIG.path.login);
        } else {
          this.props.history.push({ pathname: CONFIG.path.sessionEnded, state: { waitingScreenMessage: error.code } });
        }
        // this.state.isOtherAgentAttending = true;
      }
    );
  };

  changeLogoToDefault = () => {
    this.props.setLogoImage(logo);
    organisationAction.setLogoUrl(logo);
  }

  joinAgain = (connectionStatus) => {
    if (connectionStatus === true) {
      getTerminalInfo().then ( terminalInfo => {
        sessionActions.joinSessionAction(this.props.sessionKey, this.props.uriIdentifier, terminalInfo, this.state.speedTest, this.props.userName, false, this.props.endUserToken).then(
          response => {
            let sessionJoinPayload = {
              data: {
                category: socketMessage.category.SESSION,
                action: socketMessage.subCategories.SESSION.JOIN,
                userName: this.props.userName,
                sessionKey: this.props.sessionKey,
                token: response.data.data.token
              }
            };
            this.props.sendWebsocketMessage(
              socketMessage.events.MESSAGE,
              sessionJoinPayload
            );
          },
          error => {
            if (error.code === ERROR.INVALID_SESSION) {
              this.props.setQrError(error.code)
              this.props.history.replace(CONFIG.path.qrExpired);
            }
          }
        );
      });
    }
  }

  checkSession = () => {
    sessionActions.checkSessionData(this.sessionKey, this.props.uriIdentifier).then(
      response => {
        if (response.data) {
          if (response.data.code) {
            this.setState({waitingScreenMessage: response.data.code})
          } else{
            this.setState({waitingScreenMessage: response.data})
          }
        }
      },
      error => {
        if (error.code === ERROR.NOT_AUTHORIZED) {
          this.props.history.push(CONFIG.path.login);
        }else {
          this.props.history.push({ pathname: CONFIG.path.sessionEnded, state: { waitingScreenMessage: error.code } });
        }
      }
    )
  }

  render() {
    return (
      <div className="videoCall">
        {this.props.qrActiveScreen == "QR_SPLASH_SCREEN" ?
          // only to be displayed for user 
          <SplashScreen
            selectedLanguage={this.props.selectedLanguage}
            setLanguageAction={this.props.setLanguageAction}
            handleStartClick={this.handleStartClick}
            handleChangeLanguage={this.handleChangeLanguage}
            logoUrl={this.props.logoUrl}
            updateProfile={this.props.updateProfile}
            isLogoPresent={this.state.isLogoPresent}
            errorMessage={this.state.errorMessage}
            gottenWording={this.props.gottenWording}
            isWordingGotten={this.props.isWordingGotten}
            isSpeedTestRunning={this.state.isSpeedTestRunning}
            speedTestRemainingTime={this.state.speedTestCountTime}
            speedTestResult={this.state.speedTest.result}
            ownSpeedTestError={this.props.ownSpeedTestError}
          /> : this.props.qrActiveScreen == "QR_WAITING_SCREEN" ?
            (<LoadingScreen
              logoUrl={this.props.logoUrl}
              isLogoPresent={this.state.isLogoPresent}
              // showMeetingEnded={
              //   this.props.isSessionEnded ||
              // (this.props.latestUpdatedParticipant &&
              //   this.props.latestUpdatedParticipant.status === "LEFT") ||
              // !this.props.sessionKey ||
              // !this.props.sessionStatus ||
              // this.props.sessionStatus === SESSION_STATUS.CLOSING
              // }
              selectedLanguage={this.props.selectedLanguage}
              joinAgain={this.joinAgain}
              setLanguageAction={this.props.setLanguageAction}
            />
            // only to be displayed for agent
            ) : 
            (this.state.waitingScreenMessage == null ? null
              : 
              (<AgentSplashScreen
                handleStartClick={this.handleAgentStartClick}
                gottenWording={this.props.gottenWording}
                isWordingGotten={this.props.isWordingGotten}
                setLanguageAction={this.props.setLanguageAction}
              />)
            )
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    sessionKey: selectSessionKey(state),
    userRole: selectUserRole(state),
    token: selectUserToken(state),
    endUserToken: selectEndUserToken(state),
    sessionStatus: selectSessionStatus(state),
    userName: selectUserName(state),
    logoUrl: state.UserReducer.logoUrl,
    selectedLanguage: getLanguage(state),
    sessionType: selectSessionType(state),
    qrActiveScreen: selectQrActiveScreen(state),
    isSessionEnded: selectSessionEndedFlag(state),
    userAdmissionStatus: selectUserAdmissionStatus(state),
    uriIdentifier: state.UserReducer.uriIdentifier,
    gottenWording: state.OrganisationReducer.wordingUrl,
    isWordingGotten: state.OrganisationReducer.isWordingFetched,
    ownSpeedTestError: getOwnSpeedTestError(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      sendWebsocketMessage: sendWebsocketMessage,
      disconnectWebsocket,
      setLogoImage,
      setToken,
      setSharingFlag,
      setSdpFlag,
      setLanguageAction,
      setCustomerId,
      updateProfile,
      setQrError,
      removeSessionKeyAndToken,
      updateLatestParticipant,
      setSessionStatus,
      removeSessionDetails,
      setQrActiveScreen,
      setQrLicenseKey,
      setUserRole,
      setIsDisabledMenu,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QRCodeContainer);
